export enum ActionType {
    ISSUE_GUEST = 1,
    COPY_GUEST,
    DELETE_CARD
}